<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aBJnhf/tc-custom/9781448303595.jpg?1721404830059" alt="This image is the cover for the book Apollo Deception"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Apollo Deception
      </h1>
      <p class="bookDescription body article font2">
        <b><i>Gary Stephens is brought into a government-sanctioned cover-up when he discovers that his father helped fake the Apollo 11 moon landing in the 1960s.</i></b><br/><br/> After China announce a space mission to place their own flag next to the one US astronauts planted during the Apollo 11 mission, few people bat an eyelid. Shortly after this statement Charlie Stephens, a 81-year-old former filmmaker, is murdered. The incident is made to look like an accident, but why?<br/><br/> Going through his father’s effects, Gary Stephens – a director of beer and yogurt ads – discovers seven cans of old 35mm film. Dated before the landing, they’re identical to the footage NASA claims was shot by the Apollo 11 crew. The US flag is not and has never been in the Sea of Tranquillity, and only Tricky Dick and a handful of others knew it. <br/><br/> Why was the real nature of the Apollo 11 mission kept hidden? And what measures will be taken to keep the secret buried?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mitch Silver
      </h2>
      
      <p class="authorDescription body article"><B>Mitch Silver</B> studied History at Yale and attended Harvard Law School before becoming a writer for several of the big New York ad agencies. He is the author of <I>In Secret Service</I> and <I>The Book Worm</I>, and lives with his wife Ellen in Greenwich, Connecticut.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e1fbf65